export class DistrictInput {
    public name: string = '';
    public provinceId: number = 0;
}
